import React, {Component} from "react";

/*
* Authentication
*/
import Alt from 'alt';
import history from '../../../history';
import axios from 'axios';
import AuthActions from '../../../actions/AuthActions';
import AuthStore from '../../../stores/AuthStore';
import routes from '../../../routes';

import ExamList from '../../../components/ExamList';
import Constants from '../../../components/Constants';

import ReactTooltip from 'react-tooltip'
import Pagination from "react-js-pagination";

import DayPickerInput from 'react-day-picker/DayPickerInput';
import { formatDate, parseDate } from 'react-day-picker/moment';
import moment from 'moment';

import 'react-day-picker/lib/style.css';

import {
    Badge,
    Row,
    Col,
    Button,
    Label,
    Input,
    Collapse,

    InputGroup,
    InputGroupButton,
    Nav,
    NavItem,
    NavLink
} from "reactstrap";
import classnames from "classnames";

class ExamSearchClient extends Component {

    getInitialState(){
        return {
            setState: undefined
        }
    }

    constructor(props) {
    super(props);

    this.refreshExamList = this.refreshExamList.bind(this);
    this.filterExamsClick = this.filterExamsClick.bind(this);
    this.updateInputValue = this.updateInputValue.bind(this);
    this.updateCheckboxValue = this.updateCheckboxValue.bind(this);
    this.resetFilterExamsClick = this.resetFilterExamsClick.bind(this);

    //Calendar
    this.handleFromChange = this.handleFromChange.bind(this);
    this.handleToChange = this.handleToChange.bind(this);
    this.toggle = this.toggle.bind(this);

    this.state = {
        examList: null,
        activePage: 1,
        advancedSearchCollapse: false,
        isSearching: false,

        dateFilter: "REPORT",
        searchFilter: {
          firstResult: 0,
          maxResults: 10,

          reportStatus: "1",
          examRegister: "",
          clientName: "",
          patientName: "",
          beginExecutionDate: "",
          endExecutionDate: "",
          beginReceptionDate: "",
          endReceptionDate: "",
          beginReportDate: "",
          endReportDate: "",
          pediatricOnly: false,
          reportSearchText: "",
          genericSearchText: "",
          lowPriorityOnly: false,
          excludeLowPriorityExams: false,

          dtFrom: undefined,
          dtTo: undefined
        }
      };
    }

    componentDidMount(){
      //Busca exames
      this.refreshExamList();
    }

    toggle() {
      this.setState({ advancedSearchCollapse: !this.state.advancedSearchCollapse });
    }

    focusTo() {
      this.timeout = setTimeout(() => this.dtTo.getInput().focus(), 0);
    }

    showFromMonth() {
      const { dtFrom, dtTo } = this.state;
      if (!dtFrom) {
        return;
      }
      if (moment(dtTo).diff(moment(dtFrom), 'months') < 2) {
        this.dtTo.getDayPicker().showMonth(dtFrom);
      }
    }

    updateInputValue(evt, input) {
      let actualSearchFilter = this.state.searchFilter;
      actualSearchFilter[input] = evt.target.value;

      this.setState({
        searchFilter: actualSearchFilter
      });
    }

    updateRadioValue(evt, input) {
      let actualState = this.state;
      actualState[input] = evt.target.value;
      this.setState(actualState, function(){this.filterExamsClick();});
    }

    updateCheckboxValue(evt, input) {
      let actualSearchFilter = this.state.searchFilter;
      actualSearchFilter[input] = !actualSearchFilter[input];

      this.setState({
        searchFilter: actualSearchFilter
      }, function(){
        this.refreshExamList();
      });
    }

    refreshExamList(){
      this.setState({"isSearching": true}, function(){
        axios({
            method: 'post',
            url: Constants.apiUrl+'/api/v1/exam/client/'+AuthStore.getState().user.entity_id,
            data: this.state.searchFilter
        })
        .then(response => {
            this.setState({
                examList: response.data,
                isSearching: false
            });
        });
      });
    }

    pad(a,b){return(1e15+a+"").slice(-b)}


    filterExamsClick(){
      let actualSearchFilter = this.state.searchFilter;
      let formatedFrom = this.state.dtFrom ?
        (this.state.dtFrom.getFullYear() +"-"+this.pad((this.state.dtFrom.getMonth()+1), 2) +"-"+ this.pad(this.state.dtFrom.getDate(), 2)  +"T00:00:00.000+00:00") : null;
      let formatedTo = this.state.dtTo ?
        this.state.dtTo.getFullYear() +"-"+this.pad((this.state.dtTo.getMonth()+1), 2) +"-"+ this.pad(this.state.dtTo.getDate(), 2) +"T23:59:59.000+00:00" : null;

      if(this.state.dateFilter === "RECEPTION"){
        actualSearchFilter.beginReceptionDate = formatedFrom;
        actualSearchFilter.endReceptionDate = formatedTo
        actualSearchFilter.beginReportDate = "";
        actualSearchFilter.endReportDate = "";

      }else if(this.state.dateFilter === "REPORT"){
        actualSearchFilter.beginReceptionDate = "",
        actualSearchFilter.endReceptionDate = "",
        actualSearchFilter.beginReportDate = formatedFrom;
        actualSearchFilter.endReportDate = formatedTo;
      }

      this.setState({
        searchFilter: actualSearchFilter,
          activePage: 1
      }, function(){this.refreshExamList();});
    }

    resetFilterExamsClick(){
      this.setState({
        activePage: 1,
        dateFilter: "REPORT",

        searchFilter: {
          firstResult: 0,
          maxResults: 10,

          reportStatus: "1",
          examRegister: "",
          clientName: "",
          patientName: "",
          beginExecutionDate: "",
          endExecutionDate: "",
          beginReceptionDate: "",
          endReceptionDate: "",
          beginReportDate: "",
          endReportDate: "",
          pediatricOnly: false,
          reportSearchText: "",
          genericSearchText: "",
          lowPriorityOnly: false,
          excludeLowPriorityExams: false
        }
      }, () => this.refreshExamList());
    }

    handlePageChange(pageNumber) {

        this.setState({activePage: pageNumber});

        let filter = this.state.searchFilter;
        filter.firstResult = ((pageNumber-1) * 10);
        this.setState({
            searchFilter:  filter
        }, () => this.refreshExamList());
    }

    handleFromChange(dtFrom) {
      this.setState({ dtFrom }, () => {
        if (!this.state.to) {
          this.focusTo();
        }
      });
    }
    handleToChange(dtTo) {
      this.setState({ dtTo }, this.showFromMonth);
    }

    render() {
        if(this.state.examList == null) return(null);
        const { dtFrom, dtTo } = this.state;
        const modifiers = { start: dtFrom, end: dtTo };

        return (
            <div>
              <Row>
                <Col xs="12" md="6">
                  <InputGroup>
                    <Input type="text" id="genericSearchText" ref="genericSearchText" value={this.state.searchFilter.genericSearchText}
                      onChange={evt => this.updateInputValue(evt, "genericSearchText")} onKeyPress={event => {
                        if (event.key === 'Enter') {
                          this.filterExamsClick()
                        }
                      }} placeholder="Busca Genérica"/>
                    <InputGroupButton>
                      <Button className="margin-fix" color="warning" onClick={this.toggle} data-tip="Busca Avançada">
                        <i className="fa fa-filter"></i>
                      </Button>
                    </InputGroupButton>
                  </InputGroup>
                </Col>
              </Row>

              <Collapse isOpen={this.state.advancedSearchCollapse}>
                <Row>
                    <Col xs="3" md="2">
                        <Input type="text" id="registro" ref="examRegister" value={this.state.searchFilter.examRegister}
                          onChange={evt => this.updateInputValue(evt, "examRegister")} onKeyPress={event => {
                            if (event.key === 'Enter') {
                              this.filterExamsClick()
                            }
                          }} placeholder="Registro"/>
                    </Col>

                    <Col xs="3" md="2">
                        <Input type="text" id="cliente" value={this.state.searchFilter.clientName}
                          onChange={evt => this.updateInputValue(evt, "clientName")} onKeyPress={event => {
                            if (event.key === 'Enter') {
                              this.filterExamsClick()
                            }
                          }} placeholder="Cliente"/>
                    </Col>
                    <Col xs="3" md="2">
                        <Input type="text" id="paciente" value={this.state.searchFilter.patientName}
                          onChange={evt => this.updateInputValue(evt, "patientName")} onKeyPress={event => {
                            if (event.key === 'Enter') {
                              this.filterExamsClick()
                            }
                          }} placeholder="Paciente"/>
                    </Col>

                    <Col xs="6" md="2">
                        <Label htmlFor="excludeLowPriorityExams"></Label>
                        <Input type="checkbox" id="excludeLowPriorityExams" value={!this.state.searchFilter.excludeLowPriorityExams}
                          checked={!this.state.searchFilter.excludeLowPriorityExams}
                          onChange={evt => this.updateCheckboxValue(evt, "excludeLowPriorityExams")}/> Exibir fila de baixa prioridade
                          {'\u00A0'}
                          {
                            this.state.examList != null && this.state.examList.lowPriorityResults > 0 ?
                            <Badge color="info" pill>{this.state.examList != null ? this.state.examList.lowPriorityResults : 0}</Badge>
                            :
                            ''
                          }
                    </Col>

                    <Col xs="6" md="2">
                        <Label htmlFor="pediatricOnly"></Label>
                        <Input type="checkbox" id="pediatricOnly" value={this.state.searchFilter.pediatricOnly}
                          checked={this.state.searchFilter.pediatricOnly}
                          onChange={evt => this.updateCheckboxValue(evt, "pediatricOnly")}/> Somente Pediátricos
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <Col xs="12" md="6">
                        <Input type="text" id="report-text" value={this.state.searchFilter.reportSearchText}
                          onChange={evt => this.updateInputValue(evt, "reportSearchText")} onKeyPress={event => {
                            if (event.key === 'Enter') {
                              this.filterExamsClick()
                            }
                          }} placeholder="Texto do Laudo"/>
                    </Col>
                  </Row>
                  <br />

                  <Row>
                  <Col xs="3" md="2">
                      <Input type="radio" id="report" value="REPORT" checked={this.state.dateFilter === "REPORT"}
                        onChange={evt => this.updateRadioValue(evt, "dateFilter")}/> Data de Laudo

                      <br />

                      <Input type="radio" id="report" value="RECEPTION" checked={this.state.dateFilter === "RECEPTION"}
                        onChange={evt => this.updateRadioValue(evt, "dateFilter")}/> Data de Recepção
                  </Col>

                    <Col xs="12" md="6">
                      <DayPickerInput
                        value={dtFrom}
                        placeholder="Início"
                        format="DD/MM/YYYY"
                        formatDate={formatDate}
                        parseDate={parseDate}
                        dayPickerProps={{
                          selectedDays: [dtFrom, { dtFrom, dtTo }],
                          disabledDays: { after: dtTo },
                          toMonth: dtTo,
                          modifiers,
                          numberOfMonths: 1,
                        }}
                        locale='pt-br'
                        onDayChange={this.handleFromChange}
                        />
                        {' '} até {' '}

                        <span className="InputFromTo-to">

                        <DayPickerInput
                          ref={el => (this.dtTo = el)}
                          value={dtTo}
                          placeholder="Fim"
                          format="DD/MM/YYYY"
                          formatDate={formatDate}
                          parseDate={parseDate}
                          dayPickerProps={{
                          selectedDays: [dtFrom, { dtFrom, dtTo }],
                          disabledDays: { before: dtFrom },
                          modifiers,
                          month: dtFrom,
                          fromMonth: dtFrom,
                          numberOfMonths: 1,
                          }}
                          onDayChange={this.handleToChange}
                        />
                        </span>
                    </Col>
                  </Row>
                </Collapse>


                <br />
                <Row>
                  <Col xs="12" md="12">
                      <Button color="primary" onClick={this.filterExamsClick.bind(this)} data-tip="Pesquisar">
                        {!this.state.isSearching ? <i className="fa fa-search"></i> : <i className="fa fa-spinner fa-pulse"></i>} {'\u00A0'} Pesquisar
                      </Button>
                      {'\u00A0'}
                      <Button color="warning" onClick={this.resetFilterExamsClick.bind(this)} data-tip="Limpar Filtros">
                        <i className="fa fa-times"></i>{'\u00A0'} Limpar Filtros
                      </Button>
                  </Col>
                </Row>

                <br />


                <ExamList examList={this.state.examList} showDtReport={true}/>

                <br />
                <Pagination
                    activePage={this.state.activePage}
                    itemsCountPerPage={10}
                    totalItemsCount={this.state.examList.totalResults}
                    pageRangeDisplayed={15}
                    onChange={this.handlePageChange.bind(this)}
                />

                <ReactTooltip />

            </div>
        )
    }
}

export default ExamSearchClient;



// WEBPACK FOOTER //
// ./src/views/client/ExamSearchClient/ExamSearchClient.js